import React from "react";
import styled from "styled-components";
import theme from "../../style/theme";

interface Props {
  radioMap: { [key: string]: string };
  selectedKey: string;
  setSelectedKey: React.Dispatch<React.SetStateAction<string>>;
  name: string;
}

export const CustomRadioButton: React.FC<Props> = ({
  radioMap,
  selectedKey,
  setSelectedKey,
    name,
}) => {
  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedKey(event.target.value);
  };

  return (
    <RadioGroupContainer>
      {Object.keys(radioMap).map((key) => (
        <RadioContainer key={name+key}>
          <RadioInput
            type="radio"
            id={name+key}
            value={key}
            checked={selectedKey === key}
            onChange={handleRadioChange}
          />
          <RadioLabel htmlFor={name+key} isSelected={selectedKey === key}>
            {radioMap[key]}
          </RadioLabel>
        </RadioContainer>
      ))}
    </RadioGroupContainer>
  );
};

const RadioGroupContainer = styled.div`
  display: flex;
`;

const RadioContainer = styled.div`
  display: flex;
  align-items: center;
`;

const RadioInput = styled.input`
  appearance: none;
  width: 1.25rem;
  height: 1.25rem;
  border: 2px solid ${theme.palette.primitives.gray400};
  border-radius: 50%;
  cursor: pointer;

  &:checked {
    background: ${theme.palette.primitives.gray600};
    border: 2px solid ${theme.palette.primitives.gray600};
    outline-offset: -5px;
    outline: 3px solid white;
  }
`;

interface RadioLabelProps {
  isSelected: boolean;
}

const RadioLabel = styled.label<RadioLabelProps>`
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: ${(props) =>
    props.isSelected
      ? theme.palette.primitives.gray600
      : theme.palette.primitives.gray400};
  cursor: pointer;
`;
